import { DatePickerChangeEvent } from "@progress/kendo-react-dateinputs";
import DatePickerComponent from "ui/Date";
import { getBuyersFilterApi, getFishingGearApi, getSpecies } from "api/common";
import { RegistrationListParams } from "api/registration";
import { FishingGear } from "interface/common";
import { Vessel } from "interface/vessel";
import { FC } from "react";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import VesselRenderItem from "ui/dropdownItemList/VesselRenderItem";
import { getVesselFilter } from "api/vessel";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: RegistrationListParams) => void;
	filterOptions: RegistrationListParams;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
	onNewRegistration: () => void;
	canCreate: boolean;
	isMobileView: boolean;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			vesselRegistrationNumber: vessel.id ? vessel.rn : "",
			take: props.pageSize,
			skip: 0,
		});
	};
	const handleDate = (e: DatePickerChangeEvent) => {
		const newDate = e.target.value;

		if (newDate && isNaN(new Date(newDate).getFullYear())) {
			//console.log("is na");
			return; // Don't update the state if the date is invalid
		}
	};
	return (
		<div
			className={`filter-container  ${props.isMobileView ? "registration-filter-container" : ""}`}
		>
			<div className="filter-items registration-filter-items">
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.fromDate}
						onChange={(e) => {
							setFilterOptions({
								...filterOptions,
								fromDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							});
						}}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={filterOptions.toDate}
						onChange={(e) => {
							setFilterOptions({
								...filterOptions,
								toDate: e.target.value,
								take: props.pageSize,
								skip: 0,
							});
						}}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						itemRender={VesselRenderItem}
						value={{
							id: filterOptions.vesselId || null,
							//	nm: filterOptions.vesselName || t("ChooseVessel"),
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fartøy"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
						// popupSettings={{ width: 400 }}
					/>
				</div>
				<div style={{ width: "200px" }}>
					<CustomDropDownList
						data={[]}
						value={{
							code: filterOptions.fishingGearId || null,
							//	displayName: filterOptions.fishingGear || t("ChooseFishingGear"),
							displayName: filterOptions.fishingGear || " ",
						}}
						className="height-inherit"
						dataItemKey="code"
						label={t("FishingGear")}
						textField="displayName"
						serverFilter={true}
						filterable={true}
						serverFilterApi={getFishingGearApi}
						defaultItem={{ value: null, displayName: t("All") }}
						onSelect={(gear: FishingGear) =>
							setFilterOptions({
								...filterOptions,
								fishingGearId: gear.id,
								fishingGear: gear.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						// popupSettings={{ width: 400 }}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						onSelect={(species) =>
							setFilterOptions({
								...filterOptions,
								speciesCode: species.code,
								species: species.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						label={t("Species")}
						value={{
							code: filterOptions.speciesCode || null,
							//name: filterOptions.species || t("ChooseSpecies"),
							name: filterOptions.species || " ",
						}}
						dataItemKey="code"
						textField="name"
						defaultItem={{ code: null, name: t("All") }}
						filterable={true}
						serverFilter={true}
						serverFilterApi={getSpecies}
						className="height-inherit"
						// popupSettings={{ width: 400 }}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id,
								buyerName: buyer.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							//	displayName: filterOptions.buyerName || t("ChooseBuyer"),
							displayName: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="displayName"
						label={t("Buyer")}
						defaultItem={{ id: null, displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
						popupSettings={{ width: 400 }}
					/>
				</div>
			</div>

			<div className="filter-end-btn registration-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
					btnStyle={{ width: "160px" }}
				/>
				{props.canCreate && (
					<CustomButton
						label={t("NewRegistration")}
						onClick={props.onNewRegistration}
						iconName={ICON_NAMES.Plus}
						btnStyle={{ width: "160px" }}
					/>
				)}
			</div>
		</div>
	);
};

export default Filter;
